import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActTracker } from 'src/logic/act-tracker';
import { Actions } from 'src/logic/enum/actions';
import { OperationParam } from 'src/logic/enum/operation-param';
import { TaskTrackerItemState } from 'src/logic/enum/task-tracker-item-state';
import { Model } from 'src/logic/model';
import { TaskTrackerItemSubItem } from 'src/logic/types/task-tracker/task-tracker-item-sub-item';
import { ContextMenuItem, ContextMenuPosition } from '../context-menu/context-menu.component';
import { TaskTrackerSubItemActionParam } from "src/logic/types/task-tracker/task-tracker-sub-item-action-param";

@Component({
    selector: 'app-task-tracker-item',
    templateUrl: './task-tracker-item.component.html',
    styleUrls: ['./task-tracker-item.component.less'],
    standalone: false
})
export class TaskTrackerItemComponent implements OnInit {

  constructor(public model: Model, public actTracker: ActTracker, private route: ActivatedRoute) { }

  TaskTrackerItemState = TaskTrackerItemState;

  @ViewChild('mainText')
  mainText!: ElementRef;

  noteMode: boolean = true;
  isLeftResize: boolean = false;
  contextMenuPosition: ContextMenuPosition = { x:0, y:0 };
  textNewSubItem: string = '';
  queryParamsSubscription:any;
  /**не передан noteId */
  noNoteIdParam: boolean = false;

  /**пункт на котором открыто меню */
  menuOpenedSubItem: TaskTrackerItemSubItem | null = null;

  editingSubItem: { item: TaskTrackerItemSubItem | null, positionEdit: number, nameEdit: string  } = 
                  { item: null, positionEdit: 1, nameEdit: '' };

  /**для автосохранения текста */
  autoSaveTimerHandle: any = null;

  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  get leftBlockWidthVal() {
    return `${this.model.taskItem.leftBlockWidth}px`;
  }

  mainCursor: string = 'default';

  contextMenuItems: ContextMenuItem[] = [
    {name:'Пункт выполнен',value:'stateDone'}
    ,{name:'Пункт вып=>след',value:'stateDoneNext'}
    ,{name:'Имя в текст',value:'nameToText'}
    ,{name:'Редактировать',value:'edit'}
    ,{name:'Пункт в работе',value:'stateInProgress'}
    ,{name:'Пункт неактивный',value:'stateNotActive'}
    ,{name:'Пункт исключить',value:'stateRemoved'}
    ,{name:'Пункт удалить',value:'subitemDelete'}];

  ngOnInit(): void {
    // this.id = this.activatedRoute.snapshot.params["id"];
    // console.log(this.activatedRoute.snapshot.params["id"]);
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {

      console.log('route change',params);

      if(!params.id||params.id.length<1){       
        this.noNoteIdParam = true; 
        return;
      }else{
        console.log(params.id);
        this.model.traskItemNoteId = parseInt(params.id);
        this.actTracker.do(Actions.trackerLoadItem);
      }
    });
  }

  subItemCreateClick(){
    if(this.textNewSubItem.length>0){
      this.actTracker.do(Actions.trackerSubItem, { operation: OperationParam.Add, name: this.textNewSubItem });
      this.textNewSubItem = '';
      console.log(this.model.taskItem);
    }
  }

  onNewSubItemKeyPress(ev: KeyboardEvent){
    if(ev.code==='Enter'){
      this.subItemCreateClick();
    }
  }

  onResizeLeftClick(){
    this.mainCursor = 'col-resize';
    // console.log('start resize');
    setTimeout(()=>{
      this.isLeftResize = true;
    },0);
  }

  onMainClick(ev: MouseEvent){
    if(this.isLeftResize){
      this.mainCursor = 'default';
      this.isLeftResize = false;
      this.model.taskItem.leftBlockWidth = ev.clientX;
      this.actTracker.do(Actions.trackerSaveItem);
    }
  }

  subItemClick(it: TaskTrackerItemSubItem, ev: MouseEvent){
    if(!it.edit){
      if(!this.model.taskItem.subItems.some((t)=>t.menuOpened)){
        console.log('subItemClick',ev, it);
        this.contextMenuPosition.x = ev.offsetX-10;
        this.contextMenuPosition.y = ev.offsetY;
        it.menuOpened = true;
        this.menuOpenedSubItem = it;
      }
    }
  }

  onMenuItemClose(it: TaskTrackerItemSubItem){
    setTimeout(()=>{
      it.menuOpened = false;
      this.menuOpenedSubItem = null;
    },0)
  }

  onMenuItemSelect(it: ContextMenuItem){
    console.log('select',it);
    switch(it.value){
      case 'edit': {
          this.model.taskItem.subItems.forEach((it)=>{
            it.menuOpened = false;
            it.edit = false;
          });
          this.editingSubItem = { item: this.menuOpenedSubItem
                              , positionEdit: this.menuOpenedSubItem?.position ?? 1
                              , nameEdit: this.menuOpenedSubItem?.name ?? '' };
          if(this.menuOpenedSubItem)
            this.menuOpenedSubItem.edit = true;
        }
        break;
      case 'stateInProgress':
        this.actTracker.do(Actions.trackerChangeSubItemState, { state: TaskTrackerItemState.InProgress, subItem: this.menuOpenedSubItem });
        break;
      case 'stateDone':
        this.actTracker.do(Actions.trackerChangeSubItemState,  { state: TaskTrackerItemState.Done, subItem: this.menuOpenedSubItem });
        break;
      case 'stateDoneNext': {
        let itemIndex = this.model.taskItem.subItems.indexOf(this.menuOpenedSubItem ?? new TaskTrackerItemSubItem()) + 1;
        this.actTracker.do(Actions.trackerChangeSubItemState,  { state: TaskTrackerItemState.Done, subItem: this.menuOpenedSubItem });
        if(itemIndex < this.model.taskItem.subItems.length){
          this.actTracker.do(Actions.trackerChangeSubItemState,  { state: TaskTrackerItemState.InProgress, subItem: this.model.taskItem.subItems[itemIndex] });
        }
        }
        break;
      case 'stateRemoved':
        this.actTracker.do(Actions.trackerChangeSubItemState, { state: TaskTrackerItemState.Removed, subItem: this.menuOpenedSubItem });
      break;
      case 'stateNotActive':
          this.actTracker.do(Actions.trackerChangeSubItemState, { state: TaskTrackerItemState.NotActive, subItem: this.menuOpenedSubItem });
      break;
      case 'subitemDelete':
          this.actTracker.do(Actions.trackerSubItem, { operation: OperationParam.Del, subItem: this.menuOpenedSubItem });
      break;
      case 'nameToText': {
        console.log(this.model.taskItem.mainText, this.model.taskItem.mainText.length);
          this.model.taskItem.mainText += this.menuOpenedSubItem?.name;
          this.model.trackerItemMainTextInnerHtml = this.model.taskItem.mainText;
          this.mainText.nativeElement.focus();
          setTimeout(()=>{
            this.placeCaretAtEnd(this.mainText.nativeElement);
          },0);

      }
      break;
    }
  }

  placeCaretAtEnd(el: any) {
    var range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    var sel: any = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
}

  subItemSaveClick(){
    setTimeout(()=>{
    if(this.editingSubItem && this.editingSubItem.item){
        this.editingSubItem.item.edit = false;
        this.editingSubItem.item.position = this.editingSubItem.positionEdit;
        this.editingSubItem.item.name = this.editingSubItem.nameEdit;
        this.actTracker.do(Actions.trackerSubItem, { operation: OperationParam.Update, subItem: this.editingSubItem.item });
      }
      },0);
  }

  subItemCancelClick(){
    setTimeout(()=>{
      if(this.editingSubItem && this.editingSubItem.item)
        this.editingSubItem.item.edit = false;
      },0);
  }

  onMainTextKeyUp(){
    if(this.autoSaveTimerHandle){
      clearTimeout(this.autoSaveTimerHandle);
    }
    this.autoSaveTimerHandle = setTimeout(()=>{
      this.actTracker.do(Actions.trackerSaveItem);
    },2000);
  }

  onMainTextInput(text: string | null){
    this.model.taskItem.mainText = text ?? '';
  }

  finalMessageClick(){
    this.model.taskItem.finalMessageHidden = true;
    this.actTracker.do(Actions.trackerSaveItem);
  }
  
}

